import { Delete } from "@mui/icons-material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import ActionButton from "../../../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";

const UIText = {
  "es-CL": { label: "Eliminar" },
  "en-US": { label: "Delete" },
};
const DeleteUser = () => {
  const { dispatch, UI } = useUIBp();
  const selected = UI.selected ?? [];


  const onClick = () => {
    dispatch(
      UIactions.openModal({
        type: "delete-users",
        payload: { users: selected},
      })
    );
  };

  return (
    <ActionButton
      {...{ disabled: !selected.length, onClick, UIText, icon: <Delete /> }}
    />
  );
};

export default DeleteUser;
